/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneCustomOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneCustomOptions/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreateInvoice/Charges/Charge/Type/Content",
  isInvalid
  
}) {
let chargeTypesValueData = fromData.useDataValue({ viewPath,
context: 'charge_types',
})
let chargeTypeIdValueData = fromData.useDataValue({ viewPath,
context: 'charge',
path: 'type_id',
})
let chargeTypeIdIsValidData = fromData.useDataIsValid({ viewPath,
context: 'charge',
path: 'type_id',
validate: fromValidate.number,
required: true,
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath,
  isInvalid
  
})
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 maxWidth={350}
 marginTop={0}
 data="charge_types"
 from={chargeTypesValueData}
 data="charge.type_id"
 value={chargeTypeIdValueData}
 onChange={onChange}
 validate="/Data/validate.js number"
 isInvalid={!chargeTypeIdIsValidData}
 required={true}
 placeholder="Select type of charge"
>
{childProps => (
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneCustomOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneCustomOptions`}
/>
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
</React.Fragment>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}